// TODO: unit test
const nonDeletedHonorific = ['mr', 'ms', 'miss', 'mrs', 'dr'];

const checkHonorific = val => nonDeletedHonorific.some(item => val === item);

export default checkHonorific;
